import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PermissionsService} from '../../../shared/permissions.service';
import {PermissionAssignment, PermissionSubjectType} from 'smag-commons/dto/api';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'app-subject-permissions',
    templateUrl: './subject-permissions.component.html',
    styleUrls: ['./subject-permissions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubjectPermissionsComponent implements OnInit, OnChanges {

    @Input() subject: [PermissionSubjectType, string];

    assignments: BehaviorSubject<PermissionAssignment[]>;

    constructor(private readonly permissionsService: PermissionsService) {
        this.assignments = new BehaviorSubject<PermissionAssignment[]>(null);
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('subject' in changes) {
            this.loadPermissions();
        }
    }

    private loadPermissions() {
        const [subjectType, subjectId] = this.subject;
        this.assignments.next(null); // trigger loading spinner
        this.permissionsService.getPermissionsForSubject(subjectType, subjectId).subscribe(assignments => {
            this.assignments.next(assignments);
        });
    }
}
